module.exports = __webpack_public_path__ + "img/ToyFaces_Colored_BG_70.43c64648.jpg";